export default "__VITE_ASSET__4a5b0bd1__"